import type { IconData } from '@stacksjs/iconify-core'

export const smileyDrool: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3s21 9.402 21 21Z\"/><path stroke-linecap=\"round\" d=\"M11 19c.817-2.878 3.951-4.586 7-3.815M37 19c-.817-2.878-3.951-4.586-7-3.815\"/><path d=\"m31 34.748l.012-.008A2.5 2.5 0 0 0 36 34.5V27a2 2 0 0 0-1.998-2H13.998c-1.104 0-2.015.902-1.833 1.992C13.114 32.672 18.05 37 24 37q.505 0 1-.041V37a3 3 0 0 0 6 0z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default smileyDrool
